import { createContext, useContext, useState } from "react";
import { SupportFixed } from "./SupportFixed";

type SupportContextType = {
  isOpen: boolean;
  selectedOrderId: string | null;
  selectedJobId: string | null;
  openSupport: () => void;
  closeSupport: () => void;
  selectOrder: (orderId: string) => void;
  selectJob: (jobId: string) => void;
};

const SupportContext = createContext<SupportContextType | undefined>(undefined);

export const SupportProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState<string | null>(null);
  const [selectedJobId, setSelectedJobId] = useState<string | null>(null);

  const openSupport = () => {
    setIsOpen(true);
  };

  const closeSupport = () => {
    setIsOpen(false);
    setSelectedOrderId(null);
    setSelectedJobId(null);
  };

  const selectOrder = (orderId?: string) => {
    if (orderId) {
      setSelectedJobId(null);
      setSelectedOrderId(orderId);
    } else {
      setSelectedOrderId(null);
    }
  };

  const selectJob = (jobId: string) => {
    setSelectedOrderId(null);
    setSelectedJobId(jobId);
  };

  return (
    <SupportContext.Provider
      value={{
        isOpen,
        selectedOrderId,
        selectedJobId,
        openSupport,
        closeSupport,
        selectOrder,
        selectJob,
      }}
    >
      {children}
      <SupportFixed is_active={isOpen} set_is_active={setIsOpen} />
    </SupportContext.Provider>
  );
};

export const useSupport = () => {
  const context = useContext(SupportContext);
  if (context === undefined) {
    return {
      isOpen: false,
      selectedOrderId: null,
      selectedJobId: null,
      openSupport: () => {},
      closeSupport: () => {},
      selectOrder: () => {},
      selectJob: () => {},
    };
  }
  return {
    isOpen: context.isOpen,
    selectedOrderId: context.selectedOrderId,
    selectedJobId: context.selectedJobId,
    openSupport: context.openSupport,
    closeSupport: context.closeSupport,
    selectOrder: context.selectOrder,
    selectJob: context.selectJob,
  };
};
